import { css } from '@linaria/core';
import { baseTheme, theming } from 'styles/utils';
export const shapeBoxWrapper = "omponents__ShapePill__ShapePill_styles_ts-shapeBoxWrapper-s15sw6c0";
export const hoverThumbStyles = "omponents__ShapePill__ShapePill_styles_ts-hoverThumbStyles-h199m6w8";

require("./ShapePill.styles.linaria.module.css!=!../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./ShapePill.styles.ts");